<template>
  <div id="ecomotoriMap">
    <router-view :key="$route.path"/>
  </div>
</template>
<script>
    import { serverBus } from './main';
    import Fuels from './models/fuels';
    import Api from "./api";

  export default {
    name: "Home",
    metaInfo() {
      return {
        title: this.title,
        meta: [
          {vmid: 'description', name: 'description', content: this.description},
          {vmid: 'keywords', name: 'keywords', content: this.keywords},
          {vmid: 'ogtitle', property: 'og:title', content: this.title},
          {vmid: 'ogdescription', property: 'og:description', content: this.description}
        ]
      }
    },
    data() {
      return {
        capabilities: false,
        page: 'App',
        methods: {},
        title: null,
        description: null,
        keywords: null,
        last_url: null
      };
    },
    created() {
      var $scope = this;

      serverBus.$on('pageChanged', (data) => {
        this.page = data.page;
        var url;

        switch (this.page) {
          case 'MapRoute':
            url = ['/map', '#', Fuels.getById(data.fuel).slug, 'Calcolo_Itinerario'].join('/');
            break;
          default:
            //serverBus.$emit('urlChanged', this.last_url);
            url = this.last_url;
            break;
        }

        if ($scope.capabilities.seochangeurl) {

          history.pushState(null, null, url);

          // da levare nel caso di inclusione tramite JS
          window.parent.postMessage(
                  {
                    event_id: 'map_metas',
                    data: {
                      url: url,
                      title: $scope.title,
                      description: $scope.description,
                      keywords: $scope.keywords
                    }
                  }, '*'
          );

        }
      });

      serverBus.$on('urlChanged', (url) => {
        this.last_url = url;

        var _components = url.split('/');

        var _fuel = _components[3];
        var _country = _components[4];
        var _region = _components[5];
        var _province = _components[6];

        var _lenght = _components.length;

        if (_components[_components.length - 1] === '') _lenght -= 1;

        switch (_lenght) {
          case 8:

            var _station = _components[7].split('-');
            var _addresses = _station[2].split('_');

            var _brand = _addresses[0];
            var _city = _addresses[1];
            var _address = _addresses[2];

            $scope.title = `Distributori auto ${_fuel} - ${_country} ${_region} ${_province} ${_brand} ${_city} ${_address}`;
            $scope.description = `Scopri tutti i distributori per la tua auto a ${_fuel} in provincia di ${_province} come il distributore ${_brand} ${_city} ${_address}`;
            $scope.keywords = `distributori,auto,${_fuel},${_country},${_region},${_province},${_brand},${_city},${_address}`;
            break;
          case 7:
            $scope.title = `Distributori auto ${_fuel} - ${_country} ${_region} ${_province}`;
            $scope.description = `Scopri tutti i distributori per la tua auto a ${_fuel} in provincia di ${_province} - ${_country}`;
            $scope.keywords = `distributori,auto,${_fuel},${_country},${_region},${_province}`;
            break;
          case 6:
            $scope.title = `Distributori auto ${_fuel} - ${_country} ${_region}`;
            $scope.description = `Scopri tutti i distributori per la tua auto a ${_fuel} in provincia di ${_region} - ${_country}`;
            $scope.keywords = `distributori,auto,${_fuel},${_country},${_region}`;
            break;
          case 5:
            $scope.title = `Distributori auto ${_fuel} - ${_country}`;
            $scope.description = `Scopri tutti i distributori per la tua auto a ${_fuel} in ${_country}`;
            $scope.keywords = `distributori,auto,${_fuel},${_country}`;
            break;
          case 4:
            $scope.title = `Distributori auto ${_fuel}`;
            $scope.description = `Scopri tutti i distributori per la tua auto a ${_fuel}`;
            $scope.keywords = `distributori,auto,${_fuel}`;
            break;
          case 3:
            $scope.title = `Distributori auto`;
            $scope.description = `Scopri tutti i distributori per la tua auto`;
            $scope.keywords = `distributori,auto`;
            break;
        }
      });

      Api.initMap(ecomotori_key, function (err, capabilities) {
        if (!err) $scope.capabilities = capabilities;

        serverBus.$emit('capabilitiesUpdated', capabilities);

        if ($scope.capabilities.seochangeurl) {
          window.parent.postMessage(
                  {
                    event_id: 'map_metas',
                    data: {
                      url: $scope.last_url,
                      title: $scope.title,
                      description: $scope.description,
                      keywords: $scope.keywords
                    }
                  }, '*'
          );
        }

        serverBus.$emit('urlChanged', window.location.pathname + window.location.hash);
      });
    }
  };
</script>

<style lang="scss">
  @import url(https://fonts.googleapis.com/css?family=Roboto);
  @import url(https://fonts.googleapis.com/css?family=Merriweather);

  body {
    margin: 0px;
  }
  #ecomotoriMap {
    font-family: "Roboto";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    .panel-nav {
      height: 50px;
      text-align: right;
      .close-button {
        border: none;
        width: 40px;
        height: 40px;
        background: url('./assets/close-icon.png');
        background-repeat: no-repeat;
        background-position: center;
      }
    }

    button {
      cursor: pointer;
    }
    button:focus {
      outline: 0;
    }

    div.placeholder-text {
      text-align: center;
      line-height: 100px;
    }

    h2.panel-header {
      text-transform: uppercase;
      color: #0c71b2;
      font-size: 26px;
      font-weight: bold;
      img {
        vertical-align: bottom;
        margin-right: 5px;
      }
      padding-bottom: 20px;
      border-bottom: 1px solid #cccccc;
      margin: 0px;
    }
    .panel-body {
      text-align: left;
      position: relative;
      height: 100%;
      .padded {
        box-sizing: border-box;
        padding: 0px 30px 30px 30px;
      }
      .scroller {
        height: calc(100% - 50px);
        overflow-y: auto;
        .adswrapper {
          margin-top: 30px;
        }
      }
    }
    .slideout {
      box-sizing: border-box;
      border-top: 1px solid #f0f0f0;
      border-bottom: 1px solid #f0f0f0;
    }

    // form styles
    fieldset {
      border: none;
      padding: 0px;
      label {
        color: #515151;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 12px;
      }
      input {
        box-sizing: border-box;
        width: 100%;
        background-color: #f3f3f3;
        border: none;
        padding: 0px 10px;
        &[type=text], &[type=email] {
          line-height: 40px;
        }
        &[type=submit] {
          color: white;
          background: #515151;
          line-height: 40px;
          font-size: 14px;
          text-transform: uppercase;
          font-weight: bold;
          margin-top: 10px;
        }
      }
      select {
        width: 100%;
        color: #515151;
        background-color: #f3f3f3;
        border: none;
        line-height: 40px;
        height: 40px;
      }
      textarea {
        box-sizing: border-box;
        width: 100%;
        border: none;
        background-color: #f3f3f3;
        padding: 10px;
      }
      .form-group {
        margin-top: 10px;
      }
      .errors {
        span {
          color: red;
          font-size: 12px;
          line-height: 14px;
          text-align: right;
        }
      }
    }

    // list styles
    div.list-section {
      margin-top: 20px;
      .area {
        display: inline-block;
        float: left;
        text-transform: uppercase;
        font-weight: bold;
        width: 100px;
        font-size: 14px;
      }
    }
    ul.list {
      &.moved {
        display: inline-block;
        width: calc(100% - 100px);
      }
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        font-size: 14px;
        padding: 10px 0px 10px 10px;
        &.row-even {
          background-color: #f3f3f3;
        }
        &.row-odd {

        }
        p {
          box-sizing: border-box;
          padding: 0;
          margin: 0;
          display: inline-block;
          vertical-align: center;
          width: 100%;
          &.description {
            padding-right: 10px;
            width: calc(100% - 106px);
          }
          &.price {
            padding-right: 10px;
            width: 80px;
          }
          &.number {
            width: 90px;
            text-align: right;
          }
          &.status {
            padding-right: 10px;
            width: 90px;
            text-align: right;
            font-weight: bold;
            color: #41a52a;
            &.close {
              color: #dc4d40;
            }
          }
          &.trend {
            margin-right: 10px;
            width: 20px;
            &.UP {
              width: 0;
              height: 0;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
              border-bottom: 10px solid black;
            }
            &.DOWN {
              width: 0;
              height: 0;
              border-left: 6px solid transparent;
              border-right: 6px solid transparent;
              border-top: 10px solid #4cab36;
            }
            &.SAME {
              width: 0;
              height: 0;
              width: 6px;
              height: 5px;
              border-top: 2px solid black;
            }
          }
        }
      }
      span {
        box-sizing: border-box;
        display: block;
        margin-right: 10px;
        &.description {
          font-style: italic;
          font-size: 0.8em;
        }
      }
    }
  }
</style>
